import { Card, CardContent, Divider, Typography } from "@mui/material"
import { ReactElement } from "react";
import { blue } from "@mui/material/colors"

interface Props {
    title: string;
    children: ReactElement;
}

const SettingCard = ({ title, children }: Props) => {
    return (
        <Card elevation={2}>
            <Typography variant="body2" color="text.secondary" padding={2}>{title}</Typography>
            <Divider/>
            <CardContent sx={{ backgroundColor: blue[50] }}>
                {children}
            </CardContent>
        </Card>
    )
}

export default SettingCard;
